import React, { useState, useEffect } from 'react'
import { DateTime } from 'luxon'
import HeaderEvent from '../../molecules/header-event/header-event'
import Icon from '../../../shared/components/atoms/Icon/Icon'
import AboutContent from '../../../shared/components/molecules/about-content/about-content'
import OthersEvents from '../../../shared/components/molecules/others-events/others-events'
import ModalAuth from '../../../shared/components/molecules/modalAuth/modal-auth'
import ModalShare from '../../../shared/components/molecules/modal-share/modal-share'
import LeafaletCard from '../../../shared/components/molecules/leaflet-card/leaflet-card'
import CommentsTalk from '../../../shared/components/organisms/comments/comments'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode'
import useLocalEventLikes from '../../../shared/hooks/useLocalEventLikes'
import useSession from '../../../shared/hooks/useSessionState'
import useMobileMode from '../../../shared/hooks/useMobileMode'
import useProspectGuard from '../../../shared/hooks/useProspectGuard'
import WebinarService from '../../../shared/services/webinar'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import './live-content.scss'

const LiveContent = ({ liveInfo }) => {
  const { homeLink } = useHomeLinkMode()
  const { likesInfo, toogleLike } = useLocalEventLikes({ eventId: liveInfo.identificadorEvento })
  const { isLoggedUser } = useSession()
  const { isMobile } = useMobileMode()
  const dateEvent = DateTime.fromISO(liveInfo.fechaDelEvento || '')
    .setLocale('es-CO')
    .setZone('America/Bogota')
  const [isModalShare, setIsModalShare] = useState(false)

  const { isVisibleModalAuth, onHideModal, onSuccesRegister, userInfo } = useProspectGuard({
    redirectTo: '/academia-tena/',
    disableGuard: !liveInfo.esUnEventoExclusivo,
  })

  const userInf = dataLayerUserInfo()
  const dataLaterLive = (label, titulo, subCat, tipo, event, action) => {
    const sub = subCat !== '' ? subCat : 'ninguno'

    let location = ''
    if (typeof window !== 'undefined') {
      location = window.location.href
    }
    if (sub.toUpperCase() === 'INCONTINENCIA') {
      pushDataLayerEvent({
        event: 'Interacciones - Incontinencia',
        category: 'vista sección',
        action: 'view',
        label: titulo,
        article_name: titulo,
        location: location,
        article_type: tipo,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    } else {
      pushDataLayerEvent({
        event: event,
        category: 'academia tena',
        action: action,
        label: label,
        article_name: titulo,
        sub_category: sub,
        location: location,
        article_type: tipo,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    }
  }

  const dataLayerDuracionArticulo = (initialTime, subCat, articleName, articleType) => {
    let endTime = ''
    let location = ''
    if (typeof window !== 'undefined') {
      location = window.location.href
      endTime = (window.performance.now() - initialTime) / 1000
    }
    if (endTime > 60 && scrollFlag50 === false) {
      pushDataLayerEvent({
        event: 'content_consumption',
      })
    }
    if (subCat.toUpperCase() === 'INCONTINENCIA') {
      pushDataLayerEvent({
        event: 'Interacciones - Incontinencia',
        category: 'duración_sección',
        action: 'time',
        duration_time: `${endTime}s`,
        article_name: articleName,
        location: location,
        article_type: articleType,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    } else {
      const subCatAux = subCat !== '' ? subCat : 'niguno'
      pushDataLayerEvent({
        event: 'Interacciones - Articulos',
        category: 'duración artículo',
        action: 'time',
        duration_time: `${endTime}s`,
        article_name: articleName,
        sub_category: subCatAux,
        location: location,
        article_type: articleType,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    }
  }

  const dataLayerScrollArticulo = (scroll, subCat, articleName, articleType) => {
    let location = ''
    if (typeof window !== 'undefined') {
      location = window.location.href
    }
    if (subCat.toUpperCase() === 'INCONTINENCIA') {
      pushDataLayerEvent({
        event: 'Interacciones - Incontinencia',
        category: 'profundidad_scroll',
        action: 'scroll',
        scroll_tracking: scroll,
        article_name: articleName,
        location: location,
        article_type: articleType,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    } else {
      const subCatAux = subCat !== '' ? subCat : 'niguno'
      pushDataLayerEvent({
        event: 'Interacciones - Articulos',
        category: 'scroll_artículo',
        action: 'scroll',
        scroll_tracking: scroll,
        article_name: articleName,
        sub_category: subCatAux,
        location: location,
        article_type: articleType,
        user_data: userInf.user_data ? userInf.user_data : '',
        log_status: userInf.log_status,
      })
    }
  }

  let scrollFlag25 = true
  let scrollFlag50 = true
  let scrollFlag75 = true
  let scrollFlag100 = true
  const handleScroll = (subCat, articleName, articleType) => {
    const scrollPercentage =
      (document.documentElement.scrollTop /
        (document.documentElement.scrollHeight - document.documentElement.clientHeight)) *
      100
    if (scrollFlag25 && scrollPercentage >= 25) {
      dataLayerScrollArticulo('25', subCat, articleName, articleType)
      scrollFlag25 = false
    }
    if (scrollFlag50 && scrollPercentage >= 50) {
      dataLayerScrollArticulo('50', subCat, articleName, articleType)
      scrollFlag50 = false
    }
    if (scrollFlag75 && scrollPercentage >= 75) {
      dataLayerScrollArticulo('75', subCat, articleName, articleType)
      scrollFlag75 = false
    }
    if (scrollFlag100 && scrollPercentage >= 100) {
      dataLayerScrollArticulo('100', subCat, articleName, articleType)
      scrollFlag100 = false
    }
  }

  let initialTime = ''
  useEffect(() => {
    dataLaterLive(
      liveInfo.nombreDelEvento,
      liveInfo.nombreDelEvento,
      liveInfo.categoria !== null ? liveInfo.categoria[0].nombreDeEtiqueta : '',
      liveInfo.tipoDeEvento,
      'Article View',
      'view'
    )
    let payload = {
      cmsId: liveInfo.identificadorEvento,
      typeContent: 'CONFERENCIA',
    }

    if (typeof window !== 'undefined') {
      initialTime = window.performance.now()
      window.addEventListener('beforeunload', () => {
        dataLayerDuracionArticulo(
          initialTime,
          liveInfo.categoria !== null ? liveInfo.categoria[0].nombreDeEtiqueta : '',
          liveInfo.nombreDelEvento,
          liveInfo.tipoDeEvento
        )
      })
      window.addEventListener('scroll', () => {
        handleScroll(
          liveInfo.categoria !== null ? liveInfo.categoria[0].nombreDeEtiqueta : '',
          liveInfo.nombreDelEvento,
          liveInfo.tipoDeEvento
        )
      })
    }

    WebinarService.postView(payload)
      .then(res => {
        if (res.status === 200) {
        }
      })
      .catch(error => {
        console.log('Error registro vista', error)
      })
  }, [])

  return (
    <div className='f-live'>
      <HeaderEvent urlDelVideo={liveInfo.enlaceDelEvento} returnUrl={homeLink + 'academia-tena/'}>
        <div className='f-live__video-description'>
          {liveInfo.categoria && (
            <span className='f-live__video-description__category'>
              {liveInfo.categoria[0]?.nombreDeEtiqueta}
            </span>
          )}

          <div className='f-content'>
            <h1 className='f-content__title'>{liveInfo.nombreDelEvento}</h1>
            <h3 className='f-content__autor'>{liveInfo.encargadosDelWebinar}</h3>

            <div className='f-content__actions'>
              <p className='f-content__actions__date'>
                {dateEvent && (
                  <>
                    <Icon icon='fal fa-calendar' size='1' tagtype='i' />
                    {dateEvent.toFormat('dd/MMM/yyyy')?.toUpperCase().replace('.', '')}
                  </>
                )}
              </p>

              <button
                className='f-content__actions__btn-share'
                onClick={() => {
                  setIsModalShare(true)
                  dataLaterLive(
                    'Compartir',
                    liveInfo.nombreDelEvento,
                    liveInfo.categoria !== null ? liveInfo.categoria[0].nombreDeEtiqueta : '',
                    liveInfo.tipoDeEvento,
                    'Interacciones - Articulos',
                    'click'
                  )
                }}
              >
                <span>Compartir</span>
                <i className='icon-share'></i>
              </button>
              <button
                className='f-content__actions__btn-share'
                onClick={() => {
                  toogleLike()
                  dataLaterLive(
                    'Me gusta',
                    liveInfo.nombreDelEvento,
                    liveInfo.categoria !== null ? liveInfo.categoria[0].nombreDeEtiqueta : '',
                    liveInfo.tipoDeEvento,
                    'Interacciones - Articulos',
                    'click'
                  )
                }}
              >
                <span>Me gusta</span>
                <i className={`icon-heart ${!likesInfo?.like ? 'disabled' : ''}`}></i>
                {likesInfo?.totalLikes || 0}
              </button>
            </div>
          </div>
        </div>
      </HeaderEvent>

      <div className='f-live__about-content'>
        <AboutContent
          data={{
            sobreElEvento: liveInfo.sobreElEvento,
            dirigidoA: liveInfo.dirigidoA,
          }}
          isTalk={true}
        />
      </div>

      {liveInfo.otrosEventos && liveInfo.otrosEventos?.length > 0 && (
        <div className='f-live__others-events'>
          <OthersEvents othersEvents={liveInfo.otrosEventos} />
        </div>
      )}

      <CommentsTalk
        talkInfo={{ conferenciaId: liveInfo.identificadorEvento }}
        eventInfo={liveInfo}
        requireLogin={true}
        prospectRegister={true}
        buttonProspect='Finalizar y comentar'
        defaultProspectEmail={userInfo?.email}
      />

      <div className='f-live__leaflet-card'>
        {!isLoggedUser && <LeafaletCard isMobile={isMobile} />}
      </div>

      {isModalShare && (
        <ModalShare
          hideAction={() => {
            setIsModalShare(false)
          }}
        />
      )}

      {isVisibleModalAuth && (
        <ModalAuth
          hideAction={() => {
            onHideModal()
          }}
          validateCoverage={() => false}
          showModalCoverage={() => {
            onHideModal()
          }}
          onSuccessProspectRegister={onSuccesRegister}
          isWebinar={true}
          title={
            <>
              Para acceder al contenido de <span>TENA,</span> debes ingresar a tu cuenta o
              registrarte.
            </>
          }
        />
      )}
    </div>
  )
}

export default LiveContent
